import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BoundaryDto, FieldV2Dto, POIDto } from 'src/app/api/exa';
import { GeolocationService } from 'src/app/services/geolocation.service';
import { IconService } from 'src/app/services/icon.service';
import { Router } from '@angular/router';
import { HelperFunctions } from 'src/app/helper/helper-functions';
import { AlertService } from 'src/app/services/alert.service';
import { LocationDtoAGM } from 'src/app/pages/map/map.page';

// enum bestimmt Werte die die Map nach aussen (an übergeordnete pages ) emitten soll
export enum ExaMapEventType {
  MAP_READY = 'MAP_READY',
  FIELD_EDIT = 'FIELD_EDIT',
  FIELD_ADD = 'FIELD_ADD',
  DRAWING_FINISHED = 'DRAWING_FINISHED',
}

// Vorlage für emitter für übergeordnete Pages
export class ExaMapEvent {
  type: ExaMapEventType;
  data?: any;
}

// field information and visualization
export class FieldDtoAGM {
  field: FieldV2Dto;
  boundaryMarkerPath: google.maps.LatLngLiteral[];
  color: string;
  icon: any;
}

export class PositionMarker {
  icon: any;
  latitude: number;
  longitude: number;
}

export interface Geometry {
  boundary?: Array<BoundaryDto>;
  pois?: Array<POIDto>;
}

@Component({
  selector: 'app-map-exa',
  templateUrl: './map-exa.component.html',
  styleUrls: ['./map-exa.component.scss'],
})
export class MapExaComponent implements OnInit {
  // ============ INPUTS =================
  @Input('fields') fieldsList: FieldDtoAGM[] = [];
  @Input('locations') locationsList: LocationDtoAGM[] = [];

  @Input('drawModeActive') drawModeActive: boolean = false;

  @Input('fieldOrLocationPoints') fieldOrLocationPoints: google.maps.LatLngLiteral[] = [];
  @Input('color') color: string;

  @Input('addMode') addMode: boolean;

  // ============= OUTPUTS ===================
  @Output('onMapEvent')
  onMapEvent: EventEmitter<ExaMapEvent> = new EventEmitter();

  @Output('polygonDrawingFinished')
  polygonDrawingFinished: EventEmitter<ExaMapEvent> = new EventEmitter();

  @Output() geometryChanged: EventEmitter<Geometry> = new EventEmitter<Geometry>();

  ownPositionMarker: PositionMarker = null;

  // MAP CONFIG
  map: google.maps.Map;
  defaultZoom = 14;



  entranceIcon: google.maps.Icon = {
    scaledSize: new google.maps.Size(30, 30),
    url: '../../../assets/icon_templates/entrance_marker.svg',

  };

  exitIcon: google.maps.Icon = {
    scaledSize: new google.maps.Size(30, 30),
    url: '../../../assets/icon_templates/exit_marker.svg',
  }

  infoIcon: google.maps.Icon = {
    scaledSize: new google.maps.Size(30, 30),
    url: '../../../assets/icon_templates/info_marker.svg',
  }

  warnIcon: google.maps.Icon = {
    scaledSize: new google.maps.Size(30, 30),
    url: '../../../assets/icon_templates/warning_marker.svg',
  }

  mapOptions: google.maps.MapOptions = {
    gestureHandling: null,
    scrollwheel: true,
    disableDefaultUI: true,
  };

  chosenMapTypeId: number = 1;
  mapTypeIds = [
    google.maps.MapTypeId.ROADMAP,
    google.maps.MapTypeId.HYBRID,
    // 'satellite',
    // 'terrain'
  ];

  // VISIBILITY SETTINGS
  showFields = true;
  showLocations = true;

  // initial state of the site (for reset possibility)
  private fieldOrLocationPoints_orig: google.maps.LatLngLiteral[];
  protected polygonEdit: google.maps.Polygon;

  constructor(
    private geolocationService: GeolocationService,
    private iconService: IconService,
    private router: Router,
    private alertService: AlertService
  ) {
    this.subscribeToOwnPositionService();
    console.log(this.addMode);
    console.log(this.drawModeActive);
  }

  // MAP CONTROL BUTTONS

  onCenterOnOwnPositionClick() {
    this.map.setCenter({ lat: this.ownPositionMarker.latitude, lng: this.ownPositionMarker.longitude });
    this.map.setZoom(this.defaultZoom);
  }

  subscribeToOwnPositionService() {
    // updates own position coordinates
    this.geolocationService.onPositionChange().subscribe((pos) => {
      if (pos) {
        // create position marker if not existing
        if (!this.ownPositionMarker) {
          this.ownPositionMarker = {
            icon: this.iconService.getOwnPositionMarker(),
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          };
        } else {
          // just update the marker position
          this.ownPositionMarker.latitude = pos.coords.latitude;
          this.ownPositionMarker.longitude = pos.coords.longitude;
        }
      }
    });
  }

  mapReady(event: google.maps.Map) {
    this.map = event;
    this.onMapEvent.emit({ type: ExaMapEventType.MAP_READY });

    // set map focus on relevant details
    this.createBoundaryMarkers();

    // save initial state to be able to reset later
    this.initializeOriginalState();
  }

  onChangeMapType() {
    if (this.chosenMapTypeId < this.mapTypeIds.length - 1) {
      this.chosenMapTypeId = this.chosenMapTypeId + 1;
    } else {
      this.chosenMapTypeId = 0;
    }
  }
  //
  //     ======================================================= NG ON INIT =================================================================
  //
  ngOnInit() {
    // cleans fieldlist
    this.initializeFieldsList;
    this.initializeLocationsList;

    this.initializeColor();
  }

  // ======================== INIT METHODS =================================
  initializeOriginalState() {
    if (this.fieldOrLocationPoints && this.drawModeActive) {
      // copy input coordinate list to be able to reset
      this.fieldOrLocationPoints_orig = [];
      for (let coo of this.fieldOrLocationPoints) {
        this.fieldOrLocationPoints_orig.push(coo);
      }

      const polygonOptions: google.maps.PolygonOptions = {
        fillColor: this.color,
        fillOpacity: 0.5,
        strokeColor: this.color,
        strokeOpacity: 1.0,
        editable: true,
        map: this.map,
        paths: this.fieldOrLocationPoints,
      };
      this.polygonEdit = new google.maps.Polygon(polygonOptions);
    }
  }

  initializeFieldsList() {
    // 1) create empty list if not provided yet
    if (!this.fieldsList) {
      this.fieldsList = [];
      this.showFields = false;
    }

    // 2) if fieldsList = garbage --> empty list
    if (this.fieldsList.length == 1 && this.fieldsList[0] === null) {
      this.fieldsList = [];
      this.showFields = false;
    }
  }

  initializeLocationsList() {
    // 1) create empty list if not provided yet
    if (!this.locationsList) {
      this.locationsList = [];
      this.showLocations = false;
    }

    // 2) if locationsList = garbage --> empty list
    if (this.locationsList.length == 1 && this.locationsList[0] === null) {
      this.locationsList = [];
      this.showLocations = false;
    }
  }

  initializeColor() {
    if (!this.color) {
      this.color = '#27A89A';
    }
  }

  // =============== BOUNDARY (MAP FOCUS) ========================

  updatePolygonPaths() {
    if (this.polygonEdit) {
      this.fieldOrLocationPoints = this.polygonEdit
        .getPath()
        .getArray()
        .map((latLng: google.maps.LatLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
    }
  }

  onGeometryChanged($event) {
    console.log('onGeometryChanged: ', $event);

  }

  createBoundaryMarkers() {
    const boundaryMarkers: google.maps.LatLngBounds = new google.maps.LatLngBounds();
    // GENERATE Boundary Markers from Fields, POIs, ...
    // add them to this.markers if the markers are valid (not null)
    // if no markers were added, add Germany bounds
    // FIELDS

    // neue Fkt: getBoundaryMarkerPathsFromList
    let fieldCoordinates = this.getBoundaryMarkerPathsFromList(this.fieldsList);
    let [fieldCoordinate_SW, fieldCoordinate_NE] = this.getBoundaryMarkerCoordinatesFromLatLngLiterals(fieldCoordinates);
    if (
      !(
        fieldCoordinate_NE.lat == null ||
        fieldCoordinate_NE.lng == null ||
        fieldCoordinate_SW.lat == null ||
        fieldCoordinate_SW.lng == null
      )
    ) {
      boundaryMarkers.extend(fieldCoordinate_NE);
      boundaryMarkers.extend(fieldCoordinate_SW);
    }

    // location coordinates
    let locationCoordinates = this.getBoundaryMarkerPathsFromList(this.locationsList);
    let [locationCoordinate_SW, locationCoordinate_NE] = this.getBoundaryMarkerCoordinatesFromLatLngLiterals(locationCoordinates);
    if (
      !(
        locationCoordinate_NE.lat == null ||
        locationCoordinate_NE.lng == null ||
        locationCoordinate_SW.lat == null ||
        locationCoordinate_SW.lng == null
      )
    ) {
      boundaryMarkers.extend(locationCoordinate_NE);
      boundaryMarkers.extend(locationCoordinate_SW);
    }

    // edit Field coordinates
    let [editFieldCordinate_SW, editFieldCoordinate_NE] = this.getBoundaryMarkerCoordinatesFromLatLngLiterals(this.fieldOrLocationPoints);
    if (
      !(
        editFieldCoordinate_NE.lat == null ||
        editFieldCoordinate_NE.lng == null ||
        editFieldCordinate_SW.lat == null ||
        editFieldCordinate_SW.lng == null
      )
    ) {
      boundaryMarkers.extend(editFieldCordinate_SW);
      boundaryMarkers.extend(editFieldCoordinate_NE);
    }

    //
    if (boundaryMarkers.isEmpty()) {
      let [g1, g2] = this.getGermanyMarkers();
      boundaryMarkers.extend(g1);
      boundaryMarkers.extend(g2);
    }
    this.map.fitBounds(boundaryMarkers);
  }

  getBoundaryMarkerCoordinatesFromLatLngLiterals(coordinateList: google.maps.LatLngLiteral[]) {
    // Funktion: finde Extremste Koordinaten/ Werte in der Liste
    let min_lat: number = null;
    let max_lat: number = null;
    let min_lng: number = null;
    let max_lng: number = null;

    if (coordinateList) {
      for (let coordinate of coordinateList) {
        if (min_lat == null || coordinate.lat < min_lat) {
          min_lat = coordinate.lat;
        }
        if (min_lng == null || coordinate.lng < min_lng) {
          min_lng = coordinate.lng;
        }
        if (max_lat == null || coordinate.lat > max_lat) {
          max_lat = coordinate.lat;
        }
        if (max_lng == null || coordinate.lng > max_lng) {
          max_lng = coordinate.lng;
        }
      }
      let southEastCoordinate: google.maps.LatLngLiteral = {
        lat: min_lat,
        lng: min_lng,
      };
      let northWestCoordinate: google.maps.LatLngLiteral = {
        lat: max_lat,
        lng: max_lng,
      };
      return [southEastCoordinate, northWestCoordinate];
    } else {
      return [null, null];
    }
  }

  getGermanyMarkers() {
    // fill markers with Germany bounds
    let germanymarkers = [
      {
        lat: 47.27,
        lng: 15.03,
      },
      {
        lat: 55.05,
        lng: 5.87,
      },
    ];
    return germanymarkers;
  }

  getBoundaryMarkerPathsFromList(dtoAGMList: any[]) {
    // extracts list of boundaryMarkers from FieldDDtoAGM[] and LocationDtoAGM[]

    let boundarymarkers = [];
    if (dtoAGMList.length > 0) {
      for (let fieldOrLocation of dtoAGMList) {
        if (fieldOrLocation.boundaryMarkerPath) {
          for (let boundaryMarker of fieldOrLocation.boundaryMarkerPath) {
            boundarymarkers.push(boundaryMarker);
          }
        }
      }
    }
    return boundarymarkers;
  }

  // =================== BUTTONS ==============
  undoAction() {
    if (this.polygonEdit) {
      // delete the last point from list
      this.fieldOrLocationPoints.pop();
      this.polygonEdit.setPath(this.fieldOrLocationPoints); // may not be needed since we are working on the same array
    }
  }

  onReset() {
    if (this.polygonEdit) {
      this.fieldOrLocationPoints = [];
      for (let coo of this.fieldOrLocationPoints_orig) {
        this.fieldOrLocationPoints.push(coo);
      }
      this.polygonEdit.setPath(this.fieldOrLocationPoints); // may not be needed since we are working on the same array
    }
  }

  onSubmitDrawing() {
    if (this.polygonEdit) {
      this.updatePolygonPaths();
      this.polygonDrawingFinished.next({
        type: ExaMapEventType.DRAWING_FINISHED,
        data: {
          boundaryCoordinates: this.fieldOrLocationPoints,
          area: HelperFunctions.getHa(this.polygonEdit.getPath().getArray()),
        },
      });
    } else {
      this.alertService.openAlertToast('Bitte die Kontur schließen!', 2000);
    }
  }

  //  ================= MAP INTERACTION ==================

  onMapClick($event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
    if(!this.isPolygonReady() && this.drawModeActive) {
      // this.log.log(" usr clicked on map: ", $event);
      const coordinate: google.maps.LatLngLiteral = {
        lat: $event.latLng.lat(),
        lng: $event.latLng.lng(),
      };
      this.addPositionToPolygon(coordinate);
    }
  }

  onClosePolygon($event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
    console.log(' usr clicked on map: ', $event);
    if (!this.map) {
      return;
    }
    const coordinate: google.maps.LatLngLiteral = {
      lat: $event.latLng.lat(),
      lng: $event.latLng.lng(),
    };
    this.addPositionToPolygon(coordinate);
  }

  private addPositionToPolygon(position: google.maps.LatLngLiteral) {
    if (this.drawModeActive) {
      // add position marker to list of coordinates
      const length = this.fieldOrLocationPoints.length;
      this.fieldOrLocationPoints.push(position);
      this.polygonEdit.setPath(this.fieldOrLocationPoints); // may not be needed since we are working on the same array
    }
  }

  isPolygonReady() {
    return this.fieldOrLocationPoints && this.fieldOrLocationPoints.length > 50;
  }
}
